<template lang="pug">
v-card(class="scrollable")
  v-toolbar(
    height="40"
    color="cyan"
    dark)
    v-toolbar-title
     | Familia Genealógica del Folio -> En cada elemento: el número de matrícula inmobiliaria, esatdo, fecha de apertura y traslados
    v-spacer
    v-chip(class="mr-1 black--text" label color="yellow accent-4") Folio en el Sistema
    v-chip(class="mr-1 black--text" label color="grey") Folio NO Cargado 
    v-chip(class="mr-1 black--text" label color="red darken-1") Folio en Estudio
  v-row
    v-col(cols="8")
      folio-graph(
        :nodes="folioFamily"
        :edges="graphEdges"
        orientation="TB"
        :seed="graphFolioNumber"
        @clear-tradition="CLEAR_TRADITION_LIST"
        @node-click="handleClick")
    v-col(cols="4")
      folio-tradition-list(v-if="!vurMode" :annotation-list="traditionList")
      vur-family-logs(v-else :message-list="vurFamilyLogs")
</template>

<script>
import { mapState, mapMutations } from 'vuex';
import FolioTraditionList from '@/components/folios/FolioTraditionList.vue';
import VurFamilyLogs from '@/components/vur/VurFamilyLogs.vue';
import FolioGraph from '@/components/folios/FolioGraph.vue';

export default {

  name: 'FolioFamilyManager',

  components: {
    FolioTraditionList,
    VurFamilyLogs,
    FolioGraph,
  },

  data() {
    return {
      selectedAnnotations: [],
    };
  },

  computed: {
    ...mapState('folios', [
      'folioTradition',
      'graphFolioNumber',
      'traditionList',
      'folioFamily',
      'graphEdges',
    ]),
    ...mapState('vur', ['vurMode', 'vurFamilyLogs']),
  },

  methods: {
    ...mapMutations('folios', ['UPDATE_PARENT_LIST', 'CLEAR_TRADITION_LIST']),
    // metodo para manejar click en nodo
    handleClick({ id }) {
      // podrías abrir un modal, resaltar, mostrar info, etc.
      this.UPDATE_PARENT_LIST(id);
    },
  },
  
};
</script>

<style scoped>
.chartDiv{
    margin: 8px auto;
    padding:15px;
    border-radius:10px;
}

.truncated-folio-detail-height {
  max-height: 600px;
  overflow-y: scroll;
}
</style>